module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar leftNav bbf left"
  }, [_c('div', {
    staticClass: "home pr"
  }, [_c('span', {
    staticClass: "pa ico"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "green",
    attrs: {
      "to": "/member/info"
    }
  }, [_vm._v("账户首页")])], 1), _vm._v(" "), _c('dl', [(_vm.companyData.length !== 0) ? [_vm._m(0), _vm._v(" "), _c('dd', [_c('router-link', {
    class: _vm.getLink('/member/cart'),
    attrs: {
      "to": "/member/cart"
    }
  }, [_vm._v("购物车")]), _vm._v(" "), _c('router-link', {
    class: _vm.getLink('/member/order-list'),
    attrs: {
      "to": "/member/order-list"
    }
  }, [_vm._v("订单列表")])], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('dd', [_c('router-link', {
    class: _vm.getLink('/member/futures-inquiry'),
    attrs: {
      "to": "/member/futures-inquiry"
    }
  }, [_vm._v("询价信息")])], 1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('dd', [_c('router-link', {
    class: _vm.getLink('/member/supplylist'),
    attrs: {
      "to": "/member/supplylist"
    }
  }, [_vm._v("关注信息")])], 1), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('dd', [_c('router-link', {
    class: _vm.getLink('/member/my-trust'),
    attrs: {
      "to": "/member/my-trust"
    }
  }, [_vm._v("我的找货")])], 1), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('dd', [_c('router-link', {
    class: _vm.getLink('/member/my-logistics'),
    attrs: {
      "to": "/member/my-logistics"
    }
  }, [_vm._v("我的找车")]), _vm._v(" "), _c('router-link', {
    class: _vm.getLink('/member/my-logisticsinquiry'),
    attrs: {
      "to": "/member/my-logisticsinquiry"
    }
  }, [_vm._v("找车报价")]), _vm._v(" "), _c('router-link', {
    class: _vm.getLink('/member/my-routeinquiry'),
    attrs: {
      "to": "/member/my-routeinquiry"
    }
  }, [_vm._v("固定线路报价")])], 1)] : _vm._e()], 2), _vm._v(" "), _c('a', {
    staticClass: "quit",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("退出")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dt', [_c('i'), _vm._v("会员中心")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dt', [_c('i'), _vm._v("期货询价")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dt', [_c('i'), _vm._v("供应资源")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dt', [_c('i'), _vm._v("委托找货")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dt', [_c('i'), _vm._v("我要找车")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-68157ad2"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar.vue
// module id = 470
// module chunks = 31